module.exports = __webpack_public_path__ + "img/pay-success-tip-pic.5b007d1a.png";